<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <CRHeader :headerData="this.headerData" />
      </div>
      <div class="md-layout-item md-size-100 p-0 mt-4">
        <md-card class="if_card report-tab report-tab">
          <md-card-header class="md-card-header-icon">
            SWOT Overall SCORE:
            <template v-if="companyReportSummary.scores1 || companyReportSummary.scores2">
              <span v-if="companyReportSummary.average_score">{{ companyReportSummary.average_score }}/5</span>
              <span v-if="!companyReportSummary.average_score">N/A</span>
            </template>
            <template v-else>N/A
            </template>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                <div class="md-layout p-4">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <div class="md-layout-item md-medium-size-100 md-size-100">
                      <profile-card header-color="blue" class="text-card scores-list-star">
                        <template slot="header" header-color="rose">
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"> SWOT XPRRESS
                              SCORE: <template v-if="companyReportSummary.scores1 || companyReportSummary.scores2">{{
                                  companyReportSummary.average_score
                              }}/5
                              </template>
                              <template v-else>N/A
                              </template>
                            </div>
                          </h4>
                        </template>

                        <template slot="content">

                          <div v-if="this.companyReportSummary.scores1">

                            <h5 class="table_header m-0"> SALES‐PROFITABILITY‐MARKET OPPORTUNITY</h5>
                            <table class="table1">
                              <tr>
                                <td> Owner Earnings (%):</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores1" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores1['Owner Earnings (%)'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>


                              <tr>
                                <td> Sales Rank:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores1" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(this.companyReportSummary.scores1['Sales Rank'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                              <tr>
                                <td> Variance from Average Sales:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores1" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores1['Variance from Average Sales'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                              <tr>
                                <td> Variance from Small Business Sales:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores1" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores1['Variance from Small Business Sales'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>
                              <tr>
                                <td>Sales per Household Market Opportunity Index:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores1" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores1['Sales per Household Market Opportunity Index'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                            </table>



                            <h5 class="table_header"> OPERATING INDICATORS</h5>
                            <table class="table1">
                              <tr>
                                <td> Sales per Employee Index:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Sales per Employee Index'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>


                              <tr>
                                <td> Efficiency Index:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Efficiency Index'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                              <tr>
                                <td> Days Receivable:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Days Receivable'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                              <tr>
                                <td> Current Ratio:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Current Ratio'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>
                              <tr>
                                <td>Current Liabilities:Net Worth:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Current Liabilities:Net Worth'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>


                              <tr>
                                <td>Long Term Liabilities: Net Worth:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Total Liabilities:Net Worth'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>

                              <tr>
                                <td>Days Payable:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Days Payable'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>


                                </td>
                              </tr>


                              <tr>
                                <td>Modified Z‐Score:</td>
                                <td>
                                  <div v-if="!this.companyReportSummary.scores2" class="md-button-content">
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div v-else class="md-button-content">
                                    <md-icon
                                      v-for="(v, i) in getStars(this.companyReportSummary.scores2['Modified Z‐Score'])"
                                      :key="i">{{ v }}</md-icon>
                                  </div>
                                </td>
                              </tr>

                            </table>





                          </div>

                        </template>
                      </profile-card>
                    </div>
                  </div>
                  <div class="md-layout md-medium-size-100 md-size-50">
                    <div class="md-layout-item md-medium-size-100 md-size-100">
                      <md-card class="md-card-profile">
                        <md-card-header>
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Business Value
                              Insights</div>
                          </h4>
                        </md-card-header>
                        <md-card-content>
                          <div class="extra_space">
                            <h4>Asset Sales Value: Earnings Approach</h4>
                            <h3 class="md-subheading" v-if="companyReportSummary">
                              <strong>
                                {{
                                    companyReportSummary.customVestimate
                                }}
                              </strong>
                            </h3>
                            <p>
                              Bizminer Valuations Value basis derived from
                              projected company sales; peer group average
                              earnings %; and industry valuation multiples
                            </p>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                    <div class="md-layout-item md-medium-size-100 md-size-100">
                      <md-card class="md-card-profile">
                        <md-card-header>
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Annual Firm Sales
                            </div>
                          </h4>
                        </md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <p>
                                <strong>Firm Sales</strong>
                              </p>
                              <h3 class="md-subheading" v-if="companyReportSummary">
                                <strong>
                                  {{
                                      companyReportSummary.annual_sales
                                  }}
                                </strong>
                              </h3>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <p>
                                <strong>Firm Sales Rank</strong>
                              </p>
                              <h3 class="md-subheading" v-if="companyReportSummary">
                                <strong>
                                  {{
                                      companyReportSummary.business_sales_rank
                                  }}
                                </strong>
                              </h3>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <!--<span class="md-subheading">Lynch Mechanicals</span> -->
                    <div v-if="loading">
                      <pulse-loader class="loading" :color="'blue'" :loading="loading"></pulse-loader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <!-- <div class="md-layout-item md-size-100 p-0">
        <md-card class="if_card">
          <md-card-header class="md-card-header-icon">SWOT Scores</md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item">
                 <md-card class="md-card-profile m-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-medium-size-100 md-size-50">
                      <md-card-header class="md-card-header-icon">
                        <h4 class="title m-0">
                          <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                            SWOT SCORES
                          </div>
                        </h4>
                      </md-card-header>
                    </div>
                  </div>

              <div
                      class="md-layout-item md-medium-size-100 md-size-50 summary-scores-box-star"
                    >
                      <table-card>
                        <template slot="header" header-color="rose">
                          <h4 class="title m-0">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                            >SALES‐PROFITABILITY‐MARKET OPPORTUNITY:</div>
                          </h4>
                        </template>
                        <template slot="content">
                          <md-table v-if="swotSales" v-model="swotSales" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                {{
                                  item.title
                                }}
                              </md-table-cell>
                              <md-table-cell md-label>
                                {{
                                  item.score
                                }}
                              </md-table-cell>
                              <md-table-cell md-label class="td-actions text-right">
                                <div class="md-button-content">
                                  <md-icon v-for="n in item.score" :key="n + 'star'">star</md-icon>
                                  <md-icon
                                    v-for="n in 5 - item.score"
                                    :key="n + 'border'"
                                  >star_border</md-icon>
                                </div>
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </template>
                      </table-card>
                    </div>
               <div
                      class="md-layout-item md-medium-size-100 md-size-50 summary-scores-box-star"
                    >
                      <table-card>
                        <template slot="header" header-color="rose">
                          <h4 class="title m-0">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 card-title"
                            >OPERATING INDICATORS:</div>
                          </h4>
                        </template>
                        <template slot="content">
                          <md-table
                            v-if="swotOperatingIndicators"
                            v-model="swotOperatingIndicators"
                            table-header-color="blue"
                          >
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                {{
                                  item.title
                                }}
                              </md-table-cell>
                              <md-table-cell md-label>
                                {{
                                  item.score
                                }}
                              </md-table-cell>
                              <md-table-cell md-label class="td-actions text-right">
                                <div class="md-button-content">
                                  <md-icon v-for="n in item.score" :key="n + 'star'">star</md-icon>
                                  <md-icon
                                    v-for="n in 5 - item.score"
                                    :key="n + 'border'"
                                  >star_border</md-icon>
                                </div>
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </template>
                      </table-card>
                    </div>
                </md-card>

              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>-->
    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import GoogleMapLoader from '@/pages/Dashboard/Components/GoogleMapLoader';
import CRHeader from './CRHeader.vue';
import { ProfileCard } from '@/components';
import ratingMixin from '@/mixins/rating-mixin';

export default {
  components: {
    PulseLoader,
    // TableCard,
    // GoogleMapLoader,
    ProfileCard,
    CRHeader,
  },
  mixins: [ratingMixin],
  props: ['headerData'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    profileId() {
      return this.$route.params.id;
    },
    companyReportSummary() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    swotSales() {
      return this.companyReportSummary && this.companyReportSummary.score1
        ? Object.keys(this.companyReportSummary.scores1).map((key) => {
          return {
            title: key,
            score: this.companyReportSummary.scores1[key],
          };
        })
        : null;
    },
    inputStructure() {
      return this.companyReportSummary
        ? Object.keys(this.companyReportSummary?.input_structure).map((key) => {
          return {
            title: key,
            info: this.companyReportSummary?.input_structure[key]['value'],
          };
        })
        : null;
    },
    swotOperatingIndicators() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? Object.keys(this.companyReportSummary?.scores2).map((key) => {
          return {
            title: key,
            score: this.companyReportSummary?.scores2[key],
          };
        })
        : null;
    },
    location() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? [
          {
            CONAME: this.companyReportSummary?.input_structure['Company Name']
              .value,
            lat: this.companyReportSummary.mapData?.lat,
            lng: this.companyReportSummary.mapData?.lon,
          },
        ]
        : null;
    },
    mapCenter() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? {
          lat: this.companyReportSummary.mapData?.lat,
          lon: this.companyReportSummary.mapData?.lon,
        }
        : null;
    },
  },
  async mounted() { },
};
</script>

<style lang="scss">
.header-title {
  font-weight: bold;
  margin-top: 24px;
  font-size: 1.1rem;
}

.company-report-pdf {
  display: flex;
  justify-content: flex-end;
}

.summary-scores-box-star {
  .md-button-content {
    .md-icon {
      color: #3b7ef1;
    }
  }
}

.scores-list-star {
  .md-list {
    .md-list-item-content {
      min-height: 45px !important;

      .md-button-content {
        .md-icon {
          color: #3b7ef1;
        }
      }
    }
  }
}

.scores-list-star.other-value {
  .md-list {
    border-bottom: 1px solid #ddd;
  }
}
</style>
